module.exports = __webpack_public_path__ + "img/alpine.4762f0c2.svg";